import vSidebar from "./v-sidebar.vue";
import vSidebarItem from "./v-sidebar-item.vue";

export default Vue => {
  Vue.component("v-sidebar", vSidebar);
  Vue.component("v-sidebar-item", vSidebarItem);
};
